import Component from 'vue-class-component'
import IconButton from '@/components/buttons/richmenu/IconButton';

@Component({
  name: 'bullet-list-button',
})
export default class BulletListButton extends IconButton {
}
